/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import RequireForAccess from 'react-access';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import { update } from 'permissions/modelMasters';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import UnarchiveProductForm from './UnarchiveProductForm/UnarchiveProductForm';
import UnarchiveProductSuccess from './UnarchiveProductSuccess/UnarchiveProductSuccess';
import UnarchiveProductError from './UnarchiveProductError/UnarchiveProductError';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class UnarchiveProduct extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const product: Object = this.props.product;

    const fields: Array<Object> = [
      {
        name: 'unarchiveProductForm',
        label: t('general:actions.unarchive_product'),
        title: 'Unarchive Product',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.provide_reason'),
            rules: 'required|string',
            value: '',
            placeholder: t('general:placeholders.provide_reason'),
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          reason,
        }: //reason text
        Object = data.values().unarchiveProductForm;

        actionDrawerStore.unarchiveProduct(product.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.unarchive_product'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const product: Object = this.props.product;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.unarchive_product')} />
          <UnarchiveProductError product={product} response={actionDrawerStore.response} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.unarchive_product')} />
          <UnarchiveProductSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <RequireForAccess permissions={update}>
        <div className={styles['action-drawer-form']}>
          <ActionDrawerHeader title={t('general:actions.unarchive_product')} />
          <UnarchiveProductForm product={product} form={this.createForm()} />
        </div>
      </RequireForAccess>
    );
  }
}
